// extracted by mini-css-extract-plugin
export default {"statsContainer":"YearlyStats_statsContainer__qzK6J","statItem":"YearlyStats_statItem__iGSde","statLabel":"YearlyStats_statLabel__zf+XB","statValue":"YearlyStats_statValue__07Gd6"};